import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { GlobalLoadingService } from '../services/global-loading.service';

export const globalLoadingInterceptor: HttpInterceptorFn = (request, next) => {
  const loadingService = inject(GlobalLoadingService);

  // Skip tracking for specific endpoints if needed
  if (request.headers.get('X-Skip-Loading-Indicator') === 'true') {
    return next(request);
  }

  loadingService.trackRequestStart();

  return next(request).pipe(finalize(() => loadingService.trackRequestEnd()));
};
